import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { BooksReviewService } from "../books-review.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { WorkspacesService } from "../../workspaces.service";
import { CommonModule } from "@angular/common";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PopoverModule } from "ngx-bootstrap/popover";
import { HotToastService } from "@ngneat/hot-toast";
import { MomentModule } from "ngx-moment";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { GenericDrawerService } from "src/app/dashboard/drawer/global-drawer.service";
import { GeneralLedgerComponent } from "../general-ledger-report/general-ledger.component";

@Component({
  selector: "app-balance-sheet-review",
  imports: [CommonModule, TooltipModule, PopoverModule, MomentModule],
  templateUrl: "./profit-and-loss-review.component.html",
  styleUrl: "../balance-sheet-review/balance-sheet-review.component.scss",
})
export class ProfitAndLossReviewComponent implements OnInit {
  booksReviewService = inject(BooksReviewService);
  workspacesService = inject(WorkspacesService);
  destroyRef = inject(DestroyRef);
  toastr = inject(HotToastService);
  dashboardService = inject(DashboardService);
  genericDrawerService = inject(GenericDrawerService);

  loading: boolean = true;
  company: any;
  data: any;
  toolName = "profit-and-loss-review";
  hasAiAnalysis = false;

  @ViewChild("aiAnalysis") aiAnalysisButton: ElementRef<HTMLButtonElement>;

  ngOnInit(): void {
    this.booksReviewService.onToolChange$.next(null);

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        if (company == null) return;
        this.company = company;

        this.loadData();
      });

    this.booksReviewService.dateSelected$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadData();
      });
  }

  loadData() {
    this.hasAiAnalysis = false;
    this.loading = true;
    if (this.data) {
      this.data = null;
    }
    this.booksReviewService
      .getToolData(this.company.uuid, this.toolName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.data = res;
        this.loading = false;
      });
  }

  async runAiAnalisys() {
    this.aiAnalysisButton.nativeElement.disabled = true;
    const toastRef = this.toastr.loading("Running AI Analysis", {
      autoClose: false,
    });
    const data = {
      report: this.data.transactions,
      tool_name: this.toolName,
    };
    const response = await this.booksReviewService.getAiAnalisys(
      data,
      this.company.uuid,
    );
    this.hasAiAnalysis = true;
    toastRef.close();
    this.aiAnalysisButton.nativeElement.disabled = false;
    this.data.transactions = response.data;
  }

  findAndMark(rows, targetId) {
    for (const row of rows) {
      if (row.id === targetId) {
        row.reviewed = true;
        delete row.ai_review;
        console.log(row);
        return true;
      }
      if (row.rows && row.rows.length > 0) {
        const foundInNested = this.findAndMark(row.rows, targetId);
        if (foundInNested) {
          return true;
        }
      }
    }
    return false;
  }

  markReviewedById(targetId) {
    if (this.data.transactions && Array.isArray(this.data.transactions.rows)) {
      this.findAndMark(this.data.transactions.rows, targetId);
    }
  }

  markAsReviewed(event, transaction) {
    event.stopPropagation();
    console.log("transaction", transaction);
    this.booksReviewService
      .markTransactionAsReviewed(
        this.company.uuid,
        { [transaction.id]: transaction.id },
        transaction.id,
        this.toolName,
      )
      .then(async (res) => {
        if (res.reviewed) {
          this.markReviewedById(transaction.id);
        }
      });
  }

  async getReportDetails(report_id) {
    console.log(this.data);
    const data = {
      report_id,
      start_date: this.data.transactions.report_details_dates.start_date,
      end_date: this.data.transactions.report_details_dates.end_date,
      summarize_column_by: this.data.transactions.header.SummarizeColumnsBy,
    };
    this.dashboardService.show_loading.next(true);
    const response = await this.booksReviewService.getReportDetails(
      data,
      this.company.uuid,
    );
    this.dashboardService.show_loading.next(false);
    this.genericDrawerService.changeComponent(GeneralLedgerComponent, {
      ledgerData: response.data,
    });
  }

  navigateToQBO() {
    window.open(this.data.transactions.view_url, "_blank");
  }

  rowHasValues(row) {
    const currentTotal = Number(row?.current_total);
    const previousTotal = Number(row?.previous_total);

    return (
      (!isNaN(currentTotal) && currentTotal !== 0) ||
      (!isNaN(previousTotal) && previousTotal !== 0)
    );
  }
}
